import { reverse } from "named-urls";

const generate = (route, params = {}) => {
    return reverse(route, params);
};

export const UtilUrl = {
    generate
};